import React from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
    
    return (
        <div className="navbar-gradient">
            <nav className="navbar navbar-expand-lg container  ">
                <Link className="navbar-brand" to="/">
                    <img src={require('../assets/logo_blanco-2.png')} className="d-inline-block align-top" alt="Logo" />
                </Link>
                <h3><a href={process.env.REACT_APP_BACK_URL}><img src={require('../assets/arrow1.png')} width="25" height="17" alt="back" /> Regresar</a></h3>
            </nav>
        </div>
    );
    
}
 
export default Navbar;